module.exports = __webpack_public_path__ + "static/media/wallet-white-theme.c0d16dca.svg";